import "./App.css";
import LandingPage from "../src/pages/LandingPage/LandingPage";

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
